var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarMainStreamStreamax",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar Main Stream Record Streamax"
                                                : "Ver Detalle Main Stream Streamax"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.channel.label,
                                          items: _vm.formFields.channel.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedChannel,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.channel.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.channel,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.channel.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.channelName.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.channelName.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.channelName,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.channelName.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: _vm.formFields.enable.label
                                        },
                                        model: {
                                          value: _vm.formFields.enable.check,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.enable,
                                              "check",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.enable.check"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.resolution.label,
                                          items:
                                            _vm.formFields.resolution.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedResolution,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.resolution.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.resolution,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.resolution.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.encodeStandard.label,
                                          items:
                                            _vm.formFields.encodeStandard.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedEncodeStandard,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.encodeStandard.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.encodeStandard,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.encodeStandard.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.frameRate.label,
                                          items: _vm.formFields.frameRate.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedFrameRate,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.frameRate.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.frameRate,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.frameRate.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.quality.label,
                                          items: _vm.formFields.quality.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedQuality,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.quality.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.quality,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.quality.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.recordMode.label,
                                          items:
                                            _vm.formFields.recordMode.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedRecordMode,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.recordMode.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.recordMode,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.recordMode.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.audio.label,
                                          items: _vm.formFields.audio.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedAudio,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.audio.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.audio,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.audio.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.alarmQuality.label,
                                          items:
                                            _vm.formFields.alarmQuality.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedAlarmQuality,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.alarmQuality.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.alarmQuality,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.alarmQuality.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.encodeMode.label,
                                          items:
                                            _vm.formFields.encodeMode.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedEncodeMode,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.encodeMode.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.encodeMode,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.encodeMode.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.audioCodingFormat
                                              .label,
                                          items:
                                            _vm.formFields.audioCodingFormat
                                              .items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedAudioCodingFormat,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.audioCodingFormat
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.audioCodingFormat,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.audioCodingFormat.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.percentageMainStream
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.percentageMainStream
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields
                                                .percentageMainStream,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.percentageMainStream.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }